module.exports = __webpack_public_path__ + "img/Brown Diamond Spot 350 Headlamp.d0a1b644.jpg";